import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { PlusOutlined } from '@ant-design/icons';
import CheckList from './components/CheckList';  // 添加这行导入语句

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 20px;
`;

// Remove the unused Card component

const AddCard = styled.div`
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafafa;
  border: 2px dashed #d9d9d9;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    border-color: #1890ff;
  }
`;

function App() {
  const [lists, setLists] = useState(() => {
    // 从 localStorage 读取初始数据
    const savedLists = localStorage.getItem('checklist-data');
    return savedLists ? JSON.parse(savedLists) : [];
  });

  // 当 lists 发生变化时保存到 localStorage
  useEffect(() => {
    localStorage.setItem('checklist-data', JSON.stringify(lists));
  }, [lists]);

  const createNewList = () => {
    const newList = {
      id: Date.now(),
      title: '新建清单',
      items: [],
      createdAt: new Date().toLocaleDateString(),
      favorite: false
    };
    setLists([...lists, newList]);
  };

  const copyList = (list) => {
    const newList = {
      ...list,
      id: Date.now(),
      title: `${list.title} - ${new Date().toLocaleDateString()}`,
      items: list.items.map(item => ({...item, checked: false})),
      createdAt: new Date().toLocaleDateString(),
      favorite: false
    };
    setLists([...lists, newList]);
  };

  // 添加排序逻辑
  const sortedLists = [...lists].sort((a, b) => {
    if (a.favorite === b.favorite) {
      return b.id - a.id; // 相同收藏状态下，新创建的排在前面
    }
    return b.favorite - a.favorite; // 收藏的排在前面
  });

  return (
    <Container>
      <h1>我的清单</h1>
      <CardGrid>
        <AddCard onClick={createNewList}>
          <PlusOutlined style={{ fontSize: '24px', color: '#999' }} />
        </AddCard>
        {sortedLists.map(list => (
          <CheckList 
            key={list.id} 
            list={list} 
            onCopy={() => copyList(list)}
            onUpdate={(updatedList) => {
              setLists(lists.map(l => l.id === updatedList.id ? updatedList : l));
            }}
            onDelete={(listId) => {
              setLists(lists.filter(l => l.id !== listId));
            }}
          />
        ))}
      </CardGrid>
    </Container>
  );
}

export default App;
